import { memo, useMemo } from "react";
import useBulkWorkspaces from "../../../hooks/useBulkWorkspaces";
import { Workspace } from "../../../types/files";
import CheckSelect from "../CheckSelect";

const WorkspaceSelect: React.FC<{
    collection: string,
    workspace?: Workspace,
    state?: boolean,
    hidden?: boolean,
}> = ({ collection, workspace, state, hidden }) => {
    const { getBulkWorkspaces, addToBulk, removeFromBulk } = useBulkWorkspaces();

    const cleared = useMemo(() => !getBulkWorkspaces(collection).length, [getBulkWorkspaces, collection]);

    const selected = useMemo(() => state !== undefined ? state :
        !!getBulkWorkspaces(collection).find(ws => ws.id === workspace?.id)
    , [state, getBulkWorkspaces, collection, workspace?.id]);

    if (hidden || !workspace)
        return (<></>);

    return (
        <CheckSelect
            selected={selected}
            cleared={cleared}
            onSelect={() => addToBulk(collection, [workspace])}
            onClear={() => removeFromBulk(collection, [workspace])} />
    );
}

export default memo(WorkspaceSelect);